var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"program-soc-form"},[_c('ValidationObserver',{ref:"firstForm",scopedSlots:_vm._u([{key:"default",fn:function({ handleSubmit }){return [_c('form',{attrs:{"autocomplete":"off"},on:{"submit":function($event){$event.preventDefault();return handleSubmit(_vm.onSubmit)}}},[_c('v-row',{staticClass:"px-5 py-5",attrs:{"lg":"12"}},[_c('v-col',{staticClass:"form-separator",attrs:{"md":"12"}},[_c('h4',[_vm._v("Tanggal Sosialisasi")])]),_c('v-col',{attrs:{"lg":"6"}},[_c('geko-input',{attrs:{"item":{
            label: 'Tanggal',
            validation: ['required'],
            type: 'date',
            setter: 'date',
          }},model:{value:(_vm.formData.form_date),callback:function ($$v) {_vm.$set(_vm.formData, "form_date", $$v)},expression:"formData.form_date"}})],1),_c('v-col',{attrs:{"lg":"6"}},[_c('geko-input',{attrs:{"item":{
            label: 'Tahun Program',
            validation: ['required'],
            type: 'select',
            setter: 'program_year',
            option: {
              default_options: _vm.$_config.programYear.options.map(
                (x) => {
                  return {
                    label: x,
                    code: x,
                  };
                }
              ),
              list_pointer: {
                label: 'label',
                code: 'label',
                display: ['label'],
              },
            },
          }},model:{value:(_vm.formData.program_year),callback:function ($$v) {_vm.$set(_vm.formData, "program_year", $$v)},expression:"formData.program_year"}})],1),_c('v-col',{attrs:{"lg":"6"}},[_c('geko-input',{attrs:{"item":{
            label: 'Project',
            type: 'select-radio',
            setter: 'formData.program_type',
            option: {
              list_pointer: {
                label: 'label',
                code: 'code',
                display: ['label'],
              },
              default_options: [
                {
                  label: 'Carbon',
                  code: 2,
                },
                {
                  label: 'Non Carbon',
                  code: 3,
                },
              ],
            },
          }},model:{value:(_vm.formData.program_type),callback:function ($$v) {_vm.$set(_vm.formData, "program_type", $$v)},expression:"formData.program_type"}})],1),_c('v-col',{staticClass:"form-separator",attrs:{"md":"12"}},[_c('h4',[_vm._v("Pengisi Form")])]),_c('v-col',{attrs:{"lg":"6"}},[_c('geko-input',{attrs:{"item":{
            label: 'Nama Pengisi Form',
            validation: ['required'],
            type: 'text',
          }},model:{value:(_vm.formData.name_entry_data),callback:function ($$v) {_vm.$set(_vm.formData, "name_entry_data", $$v)},expression:"formData.name_entry_data"}})],1),_c('v-col',{attrs:{"lg":"6"}},[_c('geko-input',{attrs:{"item":{
            label: 'Jenis Kelamin',
            validation: ['required'],
            type: 'select',
            setter: 'gender',
            option: {
              default_options: [
                {
                  name: 'Laki-laki',
                  value: 'Laki-laki',
                },
                {
                  name: 'Perempuan',
                  value: 'Perempuan',
                },
              ],

              list_pointer: {
                code: 'value',
                label: 'name',
                display: ['name'],
              },
            },
          }},model:{value:(_vm.formData.gender),callback:function ($$v) {_vm.$set(_vm.formData, "gender", $$v)},expression:"formData.gender"}})],1),_c('v-col',{attrs:{"lg":"6"}},[_c('geko-input',{attrs:{"item":{
            label: 'Kontak',
            validation: ['required'],
            type: 'select',
            option: {
              default_options: [
                {
                  name: 'Tidak Ada',
                  value: 1,
                },
                {
                  name: 'Telephone Rumah',
                  value: 2,
                },
                {
                  name: 'HP',
                  value: 3,
                },
              ],

              list_pointer: {
                code: 'value',
                label: 'name',
                display: ['name'],
              },
            },
          }},model:{value:(_vm.formData.contact_type),callback:function ($$v) {_vm.$set(_vm.formData, "contact_type", $$v)},expression:"formData.contact_type"}})],1),_c('v-col',{attrs:{"lg":"6"}},[(_vm.formData.contact_type != 1)?_c('geko-input',{attrs:{"item":{
            label: 'Nomor Kontak',
            validation: ['required'],
            type: 'number',
          }},model:{value:(_vm.formData.contact_person),callback:function ($$v) {_vm.$set(_vm.formData, "contact_person", $$v)},expression:"formData.contact_person"}}):_vm._e()],1),_c('v-col',{attrs:{"lg":"6"}},[_c('geko-input',{attrs:{"item":{
            label: 'Umur',
            validation: ['required'],
            type: 'number',
          }},model:{value:(_vm.formData.age),callback:function ($$v) {_vm.$set(_vm.formData, "age", $$v)},expression:"formData.age"}})],1),_c('v-col',{attrs:{"lg":"6"}},[_c('geko-input',{attrs:{"item":{
            label: 'Merupakan Perwakilan Dari',
            type: 'select-radio',
            option: {
              list_pointer: {
                label: 'label',
                code: 'code',
                display: ['label'],
              },
              default_options: [
                {
                  label: 'Warga Desa',
                  code: 1,
                },
                {
                  label: 'Warga Dusun',
                  code: 2,
                },
                {
                  label: 'Kelompok Dalam Area',
                  code: 3,
                },
              ],
            }
          }},model:{value:(_vm.formData.people_status),callback:function ($$v) {_vm.$set(_vm.formData, "people_status", $$v)},expression:"formData.people_status"}})],1),(_vm.formData.people_status == 3)?_c('v-col',{attrs:{"lg":"6"}},[_c('geko-input',{attrs:{"item":{
            label: 'Nama Kelompok',
            validation: ['required'],
            type: 'text',
          }},model:{value:(_vm.formData.group_name),callback:function ($$v) {_vm.$set(_vm.formData, "group_name", $$v)},expression:"formData.group_name"}})],1):_vm._e(),_c('v-col',{attrs:{"lg":"6"}},[_c('geko-input',{attrs:{"item":{
            label: 'Jabatan / Posisi',
            type: 'select-radio',
            option: {
              list_pointer: {
                label: 'label',
                code: 'code',
                display: ['label'],
              },
              default_options: [
                {
                  label: 'Aparat Desa',
                  code: 1,
                },
                {
                  label: 'Tokoh Desa',
                  code: 2,
                },
                {
                  label: 'Lainnya',
                  code: 3,
                },
              ],
            }
          }},model:{value:(_vm.formData.entry_data_position),callback:function ($$v) {_vm.$set(_vm.formData, "entry_data_position", $$v)},expression:"formData.entry_data_position"}})],1),_c('v-col',{attrs:{"lg":"6"}},[_c('geko-input',{attrs:{"item":{
            label: 'Nama Jabatan / Posisi ',
            validation: ['required'],
            type: 'text',
          }},model:{value:(_vm.formData.position_name),callback:function ($$v) {_vm.$set(_vm.formData, "position_name", $$v)},expression:"formData.position_name"}})],1),_c('v-col',{attrs:{"lg":"6"}},[_c('geko-input',{attrs:{"item":{
            label: 'Pernah Ada Kegiatan Organisasi Di Area Setempat?',
            type: 'select-radio',
            option: {
              list_pointer: {
                label: 'label',
                code: 'code',
                display: ['label'],
              },
              default_options: [
                {
                  label: 'Ya, Pernah',
                  code: 1,
                },
                {
                  label: 'Tidak Pernah',
                  code: 0,
                },
              ],
            }
          }},model:{value:(_vm.formData.is_program),callback:function ($$v) {_vm.$set(_vm.formData, "is_program", $$v)},expression:"formData.is_program"}})],1),_c('v-col',{attrs:{"lg":"6"}},[(_vm.formData.is_program)?_c('geko-input',{attrs:{"item":{
            label: 'Pernah Ikut Program Tahun',
            validation: ['required'],
            type: 'select',
            option: {
              default_options: _vm.$_config.programYear.options.map(
                (x) => {
                  return {
                    label: x,
                    code: x,
                  };
                }
              ),
              list_pointer: {
                label: 'label',
                code: 'code',
                display: ['label'],
              },
            }
          }},model:{value:(_vm.formData.is_program_year),callback:function ($$v) {_vm.$set(_vm.formData, "is_program_year", $$v)},expression:"formData.is_program_year"}}):_vm._e()],1),_c('v-col',{staticClass:"form-separator",attrs:{"md":"12"}},[_c('h4',[_vm._v("Lokasi Desa")])]),_c('v-col',{attrs:{"lg":"6"}},[_c('geko-input',{attrs:{"item":{
            label: 'Management Unit',
            validation: ['required'],
            col_size: 6,
            type: 'select',
            setter: 'mu_no',
            api: 'new-utilities/management-units',
            option: {
              getterKey: 'data',
              list_pointer: {
                code: 'mu_no',
                label: 'name',
                display: ['name'],
              },
            },
          }},model:{value:(_vm.formData.mu_no),callback:function ($$v) {_vm.$set(_vm.formData, "mu_no", $$v)},expression:"formData.mu_no"}})],1),_c('v-col',{attrs:{"lg":"6"}},[_c('geko-input',{attrs:{"disabled":!_vm.formData.mu_no,"item":{
            label: 'Target Area',
            validation: ['required'],
            col_size: 6,
            type: 'select',
            setter: 'target_area',
            api: 'GetTargetArea',
            param: {
              mu_no: typeof _vm.formData.mu_no === 'object' ? _vm.formData.mu_no[0].mu_no : _vm.formData.mu_no,
            },
            option: {
              getterKey: 'data.result',
              list_pointer: {
                code: 'area_code',
                label: 'name',
                display: ['name'],
              },
            },
          }},model:{value:(_vm.formData.target_area),callback:function ($$v) {_vm.$set(_vm.formData, "target_area", $$v)},expression:"formData.target_area"}})],1),_c('v-col',{attrs:{"lg":"6"}},[_c('geko-input',{attrs:{"disabled":!_vm.formData.program_year || !_vm.formData.target_area,"item":{
            label: 'Provinsi',
            validation: ['required'],
            col_size: 6,
            type: 'select',
            setter: 'province_code',
            param: {
              page: 1,
              per_page: 10,
            },
            api: 'new-utilities/provinces',
            default_label: _vm.formData.province,
            option: {
              getterKey: 'data',
              list_pointer: {
                code: 'province_code',
                label: 'name',
                display: ['name', 'province_code'],
              },
            },
          }},model:{value:(_vm.formData.province),callback:function ($$v) {_vm.$set(_vm.formData, "province", $$v)},expression:"formData.province"}})],1),_c('v-col',{attrs:{"lg":"6"}},[_c('geko-input',{attrs:{"disabled":!_vm.formData.program_year || !_vm.formData.province,"item":{
            label: 'Kota / Kabupaten',
            validation: ['required'],
            col_size: 6,
            type: 'select',
            setter: 'kabupaten_no',
            param: {
              page: 1,
              per_page: 10,
              province_code: _vm.formData.province
            },
            api: 'new-utilities/kabupatens',
            default_label: _vm.formData.kabupaten,
            option: {
              getterKey: 'data',
              list_pointer: {
                code: 'kabupaten_no',
                label: 'name',
                display: ['name', 'kabupaten_no'],
              },
            },
          }},model:{value:(_vm.formData.city),callback:function ($$v) {_vm.$set(_vm.formData, "city", $$v)},expression:"formData.city"}})],1),_c('v-col',{attrs:{"lg":"6"}},[_c('geko-input',{attrs:{"disabled":!_vm.formData.city || !_vm.formData.program_year,"item":{
            label: 'Desa',
            validation: ['required'],
            col_size: 6,
            type: 'select',
            setter: 'village',
            api: 'new-utilities/desas',
            param: {
              program_year: _vm.formData.program_year,
              kode_ta: _vm.formData.target_area,
            },
            option: {
              getterKey: 'data',
              list_pointer: {
                code: 'kode_desa',
                label: 'name',
                display: ['name'],
              },
              multiple: true,
            },
          }},model:{value:(_vm.formData.village),callback:function ($$v) {_vm.$set(_vm.formData, "village", $$v)},expression:"formData.village"}})],1),_c('v-col',{staticClass:"form-separator",attrs:{"md":"12"}},[_c('h4',[_vm._v("Hasil Sosialisasi Program")])]),_c('v-col',{attrs:{"lg":"6"}},[_c('geko-input',{attrs:{"item":{
            label: 'Jumlah Peserta Yg Berminat',
            validation: ['required'],
            type: 'number',
          }},model:{value:(_vm.formData.total_minat),callback:function ($$v) {_vm.$set(_vm.formData, "total_minat", $$v)},expression:"formData.total_minat"}})],1),_c('v-col',{attrs:{"lg":"6"}},[_c('geko-input',{attrs:{"item":{
            label: 'Jumlah Peserta Ragu - Ragu',
            validation: ['required'],
            type: 'number',
          }},model:{value:(_vm.formData.total_ragu),callback:function ($$v) {_vm.$set(_vm.formData, "total_ragu", $$v)},expression:"formData.total_ragu"}})],1),(_vm.formData.total_minat > 0)?_c('div',[_c('v-col',{staticClass:"form-separator",attrs:{"md":"12"}},[_c('h4',[_vm._v("Calon Peserta Dalam Area Yang Memiliki Lahan (Pemilik)")])]),_c('v-col',{attrs:{"lg":"6"}},[_c('geko-input',{attrs:{"item":{
              label: 'Jumlah Peserta',
              validation: ['required'],
              type: 'number',
            }},model:{value:(_vm.formData.peserta_pemilik_people),callback:function ($$v) {_vm.$set(_vm.formData, "peserta_pemilik_people", $$v)},expression:"formData.peserta_pemilik_people"}})],1),_c('v-col',{attrs:{"lg":"6"}},[_c('geko-input',{attrs:{"item":{
              label: 'Jumlah Lahan',
              type: 'number',
            }},model:{value:(_vm.formData.peserta_pemilik_lahan),callback:function ($$v) {_vm.$set(_vm.formData, "peserta_pemilik_lahan", $$v)},expression:"formData.peserta_pemilik_lahan"}})],1),_c('v-col',{attrs:{"lg":"6"}},[_c('geko-input',{attrs:{"item":{
              label: 'Total Luas Lahan (M²)',
              type: 'number',
            }},model:{value:(_vm.formData.peserta_pemilik_luas_lahan),callback:function ($$v) {_vm.$set(_vm.formData, "peserta_pemilik_luas_lahan", $$v)},expression:"formData.peserta_pemilik_luas_lahan"}})],1),_c('v-col',{staticClass:"form-separator",attrs:{"md":"12"}},[_c('h4',[_vm._v("Calon Peserta Dalam Area Perwakilan Yg Merupakan Pengelola / Penggarap Lahan")])]),_c('v-col',{attrs:{"lg":"6"}},[_c('geko-input',{attrs:{"item":{
              label: 'Jumlah Peserta',
              validation: ['required'],
              type: 'number',
            }},model:{value:(_vm.formData.peserta_penggarap_people),callback:function ($$v) {_vm.$set(_vm.formData, "peserta_penggarap_people", $$v)},expression:"formData.peserta_penggarap_people"}})],1),_c('v-col',{attrs:{"lg":"6"}},[_c('geko-input',{attrs:{"item":{
              label: 'Jumlah Lahan',
              type: 'number',
            }},model:{value:(_vm.formData.peserta_penggarap_lahan),callback:function ($$v) {_vm.$set(_vm.formData, "peserta_penggarap_lahan", $$v)},expression:"formData.peserta_penggarap_lahan"}})],1),_c('v-col',{attrs:{"lg":"6"}},[_c('geko-input',{attrs:{"item":{
              label: 'Total Luas Lahan (M²)',
              type: 'number',
            }},model:{value:(_vm.formData.peserta_penggarap_luas_lahan),callback:function ($$v) {_vm.$set(_vm.formData, "peserta_penggarap_luas_lahan", $$v)},expression:"formData.peserta_penggarap_luas_lahan"}})],1),_c('v-col',{staticClass:"form-separator",attrs:{"md":"12"}},[_c('h4',[_vm._v("Calon Peserta Dalam Area Perwakilan Yg Memiliki Status Lainnya Terhadap Lahan")])]),_c('v-col',{attrs:{"lg":"6"}},[_c('geko-input',{attrs:{"item":{
              label: 'Jumlah Peserta',
              validation: ['required'],
              type: 'number',
            }},model:{value:(_vm.formData.peserta_lain_people),callback:function ($$v) {_vm.$set(_vm.formData, "peserta_lain_people", $$v)},expression:"formData.peserta_lain_people"}})],1),_c('v-col',{attrs:{"lg":"6"}},[_c('geko-input',{attrs:{"item":{
              label: 'Jumlah Lahan',
              type: 'number',
            }},model:{value:(_vm.formData.peserta_lain_lahan),callback:function ($$v) {_vm.$set(_vm.formData, "peserta_lain_lahan", $$v)},expression:"formData.peserta_lain_lahan"}})],1),_c('v-col',{attrs:{"lg":"6"}},[_c('geko-input',{attrs:{"item":{
              label: 'Total Luas Lahan (M²)',
              type: 'number',
            }},model:{value:(_vm.formData.peserta_lain_luas_lahan),callback:function ($$v) {_vm.$set(_vm.formData, "peserta_lain_luas_lahan", $$v)},expression:"formData.peserta_lain_luas_lahan"}})],1)],1):_vm._e(),_c('v-col',{staticClass:"form-separator",attrs:{"md":"12"}},[_c('h4',[_vm._v("Data Lahan")])]),_c('v-col',{attrs:{"lg":"6"}},[_c('geko-input',{attrs:{"item":{
            label: 'Status Legalitas Lahan',
            type: 'select',
            option: {
              multiple: true,
              list_pointer: {
                label: 'label',
                code: 'code',
                display: ['label'],
              },
              default_options: [
                {
                  label: 'Sertifikat Lahan atau letter C atas nama Sendiri',
                  code: '1',
                },
                {
                  label: 'Akte Jual beli atau Letter C masih atas nama Orang Lain',
                  code: '2',
                },
                {
                  label: 'Lahan Waris atau Lahan Sewa atau Lahan Garapan',
                  code: '3',
                },
                {
                  label: 'Lainnya',
                  code: '4',
                },
              ],
            }
          }},model:{value:(_vm.formData.lahan_legal_status),callback:function ($$v) {_vm.$set(_vm.formData, "lahan_legal_status", $$v)},expression:"formData.lahan_legal_status"}})],1),_c('v-col',{attrs:{"lg":"6"}},[(_vm.formData.lahan_legal_status.includes(4))?_c('geko-input',{attrs:{"item":{
              label: 'Status Legalitas Lahan (Lainnya)',
              validation: ['required'],
              type: 'text',
            }},model:{value:(_vm.formData.lahan_legal_status_others),callback:function ($$v) {_vm.$set(_vm.formData, "lahan_legal_status_others", $$v)},expression:"formData.lahan_legal_status_others"}}):_vm._e()],1),_c('v-col',{attrs:{"lg":"6"}},[_c('geko-input',{attrs:{"item":{
            label: 'Pola Tanam Sebelumnya',
            type: 'select',
            option: {
              multiple: true,
              list_pointer: {
                label: 'text',
                code: 'value',
                display: ['text'],
              },
              default_options: _vm.defaultData.planting_pattern,
            }
          }},model:{value:(_vm.formData.pattern),callback:function ($$v) {_vm.$set(_vm.formData, "pattern", $$v)},expression:"formData.pattern"}})],1),_c('v-col',{attrs:{"lg":"6"}},[_c('geko-input',{attrs:{"item":{
            label: 'Pola Tanam Yang Diminati',
            type: 'select',
            validation: ['required'],
            option: {
              multiple: true,
              list_pointer: {
                label: 'text',
                code: 'value',
                display: ['text'],
              },
              default_options: [
                {
                  value: 'Agroforestry',
                  text: 'Agroforestry',
                },
                {
                  value: 'Konservasi',
                  text: 'Konservasi',
                },
              ],
            }
          }},model:{value:(_vm.formData.pattern_new),callback:function ($$v) {_vm.$set(_vm.formData, "pattern_new", $$v)},expression:"formData.pattern_new"}})],1),_c('v-col',{staticClass:"form-separator",attrs:{"md":"12"}},[_c('h4',[_vm._v("Materi Pelatihan")])]),_c('v-col',{attrs:{"lg":"6"}},[_c('geko-input',{attrs:{"item":{
            label: 'Materi Pelatihan 1',
            col_size: 6,
            type: 'select',
            param: {},
            api: 'GetTrainingMaterials',
            setter: 'training1',
            // default_label: '',
            option: {
              getterKey: 'data.result',
              list_pointer: {
                label: 'material_name',
                code: 'material_no',
                display: ['material_name'],
              },
            },
          }},model:{value:(_vm.formData.training1),callback:function ($$v) {_vm.$set(_vm.formData, "training1", $$v)},expression:"formData.training1"}})],1),_c('v-col',{attrs:{"lg":"6"}},[_c('geko-input',{attrs:{"item":{
            label: 'Materi Pelatihan 2',
            col_size: 6,
            type: 'select',
            param: {},
            api: 'GetTrainingMaterials',
            setter: 'training2',
            // default_label: '',
            option: {
              getterKey: 'data.result',
              list_pointer: {
                label: 'material_name',
                code: 'material_no',
                display: ['material_name'],
              },
            },
          }},model:{value:(_vm.formData.training2),callback:function ($$v) {_vm.$set(_vm.formData, "training2", $$v)},expression:"formData.training2"}})],1),_c('v-col',{attrs:{"lg":"6"}},[_c('geko-input',{attrs:{"item":{
            label: 'Usulan Pengisi Data Untuk Trees4Trees',
            // validation: ['required'],
            type: 'textarea',
          }},model:{value:(_vm.formData.suggestion),callback:function ($$v) {_vm.$set(_vm.formData, "suggestion", $$v)},expression:"formData.suggestion"}})],1),_c('v-col',{staticClass:"form-separator",attrs:{"md":"12"}},[_c('h4',[_vm._v("Foto Dokumentasi")])]),_c('v-col',{attrs:{"lg":"6"}},[_c('geko-input',{attrs:{"item":{
            label: 'Foto Dokumentasi 1',
            path: _vm.formData.documentation1,
            type: 'upload',
            api: 'sosialisasi_program/upload.php',
            directory: 'photos/doc_collective',
            upload_type: 'image/*',
            setter: 'documentation1',
            view_data: 'documentation1',
            require_gps: true,
            option: {
              label_hint:
                'Klik gambar untuk memilih berkas yang akan diunggah',
              max_size: 5,
            },
          }},model:{value:(_vm.formData.documentation1),callback:function ($$v) {_vm.$set(_vm.formData, "documentation1", $$v)},expression:"formData.documentation1"}})],1),_c('v-col',{attrs:{"lg":"6"}},[_c('geko-input',{attrs:{"item":{
            label: 'Foto Dokumentasi 2',
            type: 'upload',
            api: 'sosialisasi_program/upload.php',
            directory: 'photos/doc_collective',
            upload_type: 'image/*',
            setter: 'documentation2',
            view_data: 'documentation2',
            require_gps: true,
            option: {
              label_hint:
                'Klik gambar untuk memilih berkas yang akan diunggah',
              max_size: 5,
            },
          }},model:{value:(_vm.formData.documentation2),callback:function ($$v) {_vm.$set(_vm.formData, "documentation2", $$v)},expression:"formData.documentation2"}})],1),_c('v-col',{staticClass:"form-separator",attrs:{"md":"12"}},[_c('div',{staticClass:"d-flex flex-row",staticStyle:{"align-items":"center"}},[_c('h4',{staticClass:"mb-0 pb-0"},[_vm._v("Jenis Tanaman Yang Diminati Calon Peserta")]),_c('v-btn',{staticClass:"circle ml-3",attrs:{"small":"","variant":"success"},on:{"click":function($event){return _vm.addRow()}}},[_c('v-icon',[_vm._v("mdi-plus")])],1)],1)]),_c('v-col',{attrs:{"md":"12"}},[_c('div',{staticClass:"bg-grey"},_vm._l((_vm.trees),function(item,i){return _c('v-expansion-panels',{key:'acc' + i + i,attrs:{"focusable":""}},[_c('v-expansion-panel',{staticClass:"mb-3"},[_c('v-expansion-panel-header',[_c('span',{class:{
                    'text-italic text-grey': !item.name,
                  }},[_vm._v(_vm._s(item.tree_name || "Masukkan Data Tanaman"))]),(_vm.trees.length > 1)?_c('div',{staticClass:"d-flex flex-row",staticStyle:{"justify-content":"flex-end"}},[_c('button',{staticClass:"text-danger",attrs:{"type":"button"},on:{"click":function($event){return _vm.deleteRow(i)}}},[_c('v-icon',{staticClass:"text-danger"},[_vm._v("mdi-delete-empty")])],1)]):_vm._e()]),_c('v-expansion-panel-content',{staticClass:"pt-4 pb-5"},[_c('v-row',[_c('v-col',{attrs:{"lg":"6"}},[_c('geko-input',{attrs:{"item":{
                        label: 'Nama Tanaman',
                        col_size: 6,
                        type: 'select',
                        setter: 'tree_code',
                        api: 'new-utilities/GetTrees',
                        option: {
                          getterKey: 'data',
                          list_pointer: {
                            code: 'tree_code',
                            label: 'tree_name',
                            display: ['tree_name'],
                          },
                        },
                      }},on:{"selected":function($event){return _vm.selectedTree($event, i)}}})],1)],1)],1)],1)],1)}),1)]),_c('v-col',{attrs:{"lg":"12"}},[_c('div',{staticClass:"d-flex flex-row",staticStyle:{"justify-content":"flex-end"}},[_c('v-btn',{attrs:{"variant":"success","type":"submit","disabled":_vm.loading || (_vm.formData.total_minat == 0 && _vm.formData.total_ragu == 0)}},[_c('v-icon',[_vm._v("mdi-plus")]),(_vm.isCreate)?_c('span',[_vm._v("Tambah Data")]):_c('span',[_vm._v("Perbaharui Data")])],1)],1)])],1)],1)]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }